<div
  [bfx-input]="bfxInput"
  [ngClass]="{'ic__fixed-ccy__container': true, 
                'ic__fixed-ccy__container--entry': !_modeDefaults, 
                'ic__fixed-ccy__container--defaults': _modeDefaults}"
>
  <button
    pButton
    type="button"
    #button
    (keyup)="keyup($event)"
    (click)="toggleCcy($event)"
    [label]="fixedCcy"
    [disabled]="disabled"
    icon="bfx-icon icon-swap_horiz"
    iconPos="right"
    [ngClass]="{
      'bfx-button-secondary-bold': true,
      'bfx-button-sm': true,
      'ic__fixed-ccy__button': true,
      'ic__fixed-ccy__button--active': !disabled,
      'ic__fixed-ccy__button--locked': disabled,
      'fixed-highlight': highlightFixed,
    }"
  ></button>
  <div *ngIf="label!=null" [ngClass]="inputDirective.labelClasses" class="ic__fixed-ccy__label">
    {{label}}
  </div>
</div>
